<template>
  <div style="position: relative">
    <transition name="fade">
      <div
        @click="subirScroll"
        v-show="mostrarIconeSubir && !subindo"
        class="icone-subir"
      >
        <unicom-icone class="icone" nome="chevron-up" :tamanho="20" />
      </div>
    </transition>
    <div>
      <div class="espacamento" style="padding-top: 48px; padding-bottom: 20px">
        <unicom-linha :espacamento="false">
          <unicom-coluna sm="12" md="8">
            <unicom-barra-pesquisa-v2
              v-model="valorBarraPesquisa"
              @limpar-campos="limparCampoPesquisa"
              @pesquisar="pesquisarObservacao"
              placeholder="Buscar observação..."
            />
          </unicom-coluna>
          <unicom-coluna sm="12" md="auto" class="ml-auto">
            <unicom-botao
              :bloco="$breakpoint.smAndDown"
              :largura="170"
              @click="mostrarFiltroObservacoes"
              contornado
              nomeIcone="sliders"
              estiloIcone="transform: rotate(90deg);"
            >
              FILTRAR
              <div class="quantidade-filtro" v-if="quantidadeFiltroObservacoes">
                {{ quantidadeFiltroObservacoes }}
              </div>
            </unicom-botao>
          </unicom-coluna>
        </unicom-linha>
        <transition name="fade">
          <div class="segunda-cor-fonte texto texto-pesquisar">
            <span v-if="textoPesquisaExiste && !pesquisandoObservacao">
              Aperte Enter para
              <span class="hover-underline" @click="pesquisarObservacao">
                pesquisar</span
              >.
            </span>
          </div>
        </transition>
      </div>
      <div class="espacamento texto-resultado">
        <transition name="fade">
          <div style="position: absolute" v-if="pesquisandoObservacao">
            Resultados da busca:
          </div>
        </transition>
      </div>
    </div>
    <div
      ref="observacoes"
      class="espacamento body-solicitacoes scroll-design"
      @scroll="onScroll"
      v-if="!loadingObservacoes"
    >
      <div v-if="observacoes.length === 0" class="subtitulo nenhum-registro">
        Nenhuma observação encontrada
      </div>

      <transition-group name="list-animation" tag="div">
        <div class="panel" v-for="obs in observacoes" :key="obs.id">
          <LinhaObservacao
            style="padding-bottom: 48px"
            @mover-scroll="moverScrollEdicao"
            :objetoObservacao="obs"
          />
        </div>
      </transition-group>
      <div>
        <unicom-spinner
          class="pb-5"
          v-show="loading"
          :tamanhoLoading="62"
          :tamanhoLinha="7"
          :velocidade="0.5"
          :marginTopTexto="30"
        />
      </div>
    </div>
    <unicom-spinner
      v-else
      class="loading-observacoes"
      :tamanhoLoading="62"
      :tamanhoLinha="7"
      :velocidade="0.5"
      :marginTopTexto="30"
      mensagem="Buscando observações..."
    />
  </div>
</template>

<script>
import LinhaObservacao from "./LinhaObservacao/LinhaObservacao";
export default {
  components: {
    LinhaObservacao
  },
  data() {
    return {
      valorBarraPesquisa: "",
      pesquisando: false,
      mostrarIconeSubir: false,
      subindo: false,
      mostrarFiltro: false
    };
  },
  mounted() {
    this.mostrarIconeSubir = false;
    this.subindo = false;
  },
  methods: {
    mostrarFiltroObservacoes() {
      this.$store.commit("setMostrarFiltroObservacoes", true);
    },
    limparCampoPesquisa() {
      this.valorBarraPesquisa = "";
      this.$store.commit("setPesquisandoObservacao", false);
      this.$store.dispatch("inicializarObservacaoStore");
    },
    onScroll(event) {
      this.mostrarIconeSubir = event.target.scrollTop > 0;

      if (this.limiteObservacao >= this.totalObservacao || this.loading) return;

      if (
        this.contemFiltroPesquisa &&
        this.limiteObservacao >= this.totalPesquisaObservacao
      )
        return;

      const content = event.target;
      const showMoreItems =
        content.scrollHeight - (content.scrollTop + content.clientHeight) < 50;

      if (this.ocorreuErro) {
        this.subirScroll();
        this.$store.commit("setOcorreuErroObservacoes", false);
        return;
      }

      if (showMoreItems) {
        this.$store.dispatch("maisObservacoes");
        //this.$emit("mais-observacoes");
      }
    },
    subirScroll() {
      this.$scrollTo(this.$el.querySelector(".panel"), 500, {
        container: this.$refs["observacoes"],
        offset: -30,
        onStart: () => {
          this.subindo = true;
        },
        onDone: () => {
          this.subindo = false;
        },
        cancelable: false
      });
    },
    moverScrollEdicao(element) {
      if (this.subindo) return;

      this.$scrollTo(element.$el, 500, {
        container: this.$refs["observacoes"],
        offset: -30
      });
    },
    pesquisarObservacao() {
      if (!this.textoPesquisaExiste) return;

      this.subirScroll();
      this.$store.dispatch("pesquisarObservacao", this.valorBarraPesquisa);
    }
  },
  computed: {
    textoPesquisaExiste() {
      return this.valorBarraPesquisa.length > 0;
    },
    observacoes() {
      return this.$store.getters.getListaObservacao;
    },
    totalObservacao() {
      return this.$store.getters.getTotalObservacao;
    },
    loading() {
      return this.$store.getters.getLoadingObservacao;
    },
    limiteObservacao() {
      return this.$store.getters.getLimiteObservacao;
    },
    offsetTopElemento() {
      return this.$store.getters.getOffsetTopElementoEditando;
    },
    loadingObservacoes() {
      return this.$store.getters.getLoadingObservacoes;
    },
    ocorreuErro() {
      return this.$store.getters.getOcorreuErroObservacoes;
    },
    pesquisandoObservacao() {
      return this.$store.getters.getPesquisandoObersavacao;
    },
    totalPesquisaObservacao() {
      return this.$store.getters.getTotalPesquisaObservacao;
    },
    objetoFiltroObservacoes() {
      return this.$store.getters.getObjetoFiltroObservacoes;
    },
    quantidadeFiltroObservacoesNumero() {
      return Object.values(this.objetoFiltroObservacoes).filter(
        e => ![null, undefined, ""].includes(e)
      ).length;
    },
    quantidadeFiltroObservacoes() {
      const qtdFiltro = this.quantidadeFiltroObservacoesNumero;
      if (qtdFiltro <= 0) return "";
      return qtdFiltro > 9 ? qtdFiltro : "0" + qtdFiltro;
    },
    contemFiltroPesquisa() {
      return (
        this.quantidadeFiltroObservacoesNumero > 0 || this.pesquisandoObservacao
      );
    }
  },
  watch: {
    valorBarraPesquisa() {
      if (this.valorBarraPesquisa.length === 0) {
        this.limparCampoPesquisa();
      }
    },
    pesquisandoObservacao() {
      if (!this.pesquisandoObservacao) {
        this.valorBarraPesquisa = "";
      }
    }
    // observacoes() {
    //   this.subirScroll();
    // }
  }
};
</script>

<style lang="scss" scoped>
.nenhum-registro {
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
  background: #f1f2f1;
}

.icone-subir {
  position: absolute;
  top: 88%;
  right: 6%;
  z-index: 2;
  cursor: pointer;

  .icone {
    background: white;
    color: black;
    width: 20px;
    border-radius: 20px;
    height: 20px;
    padding: 8px;
    border: 1px solid #9e9e9e;
  }
}

.body-solicitacoes {
  position: relative;
  height: calc(100% - 136px);
  overflow: hidden auto;
}

.subir-historico {
  &:hover {
    cursor: pointer;
    text-decoration: underline;
  }
}

.espacamento {
  padding: 0 32px;

  .texto-pesquisar {
    position: absolute;
    padding-top: 8px;
  }
}
.texto-resultado {
  padding-bottom: 28px;
}

.panel {
  transition: all 1s;
}

.loading-observacoes {
  height: calc(100% - 64px - 5rem);
  display: flex;
  flex-direction: column;
  justify-content: center;
}
</style>
